import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Documents Types */
import {
  _Documents
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    document: {},
    documentUploading: false,
    documentTokenLoading: false
  },
  mutations: {
    [_Documents.mutations.setDocument] (state, payload) {
      if (payload !== null) {
        state.document = payload
      } else {
        state.document = {}
      }
    },
    [_Documents.mutations.setDocumentUploading] (state, payload) {
      state.documentUploading = payload
    },
    [_Documents.mutations.setDocumentTokenLoading] (state, payload) {
      state.documentTokenLoading = payload
    }
  },
  actions: {
    [_Documents.actions.uploadDocument] (context, payload) {
      context.commit(_Documents.mutations.setDocumentUploading, true)

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/documents'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Documents.mutations.setDocumentUploading, false)
            ErrorHandler.clear(store)
            context.commit(_Documents.mutations.setDocument, r.data.data)
            resolve(r)
          }, function (err) {
            context.commit(_Documents.mutations.setDocumentUploading, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/documents/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_Documents.mutations.setDocumentUploading, false)
            ErrorHandler.clear(store)
            resolve(r)
            context.commit(_Documents.mutations.setDocument, r.data.data)
          }, function (err) {
            context.commit(_Documents.mutations.setDocumentUploading, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Documents.actions.getDocumentToken] (context, payload) {
      console.log('getDocumentToken: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/documents/documentToken/' + payload.id + '?filename=' + payload.filename

      context.commit(_Documents.mutations.setDocumentTokenLoading, true)

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Documents.mutations.setDocumentTokenLoading, false
          )
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          context.commit(_Documents.mutations.setDocumentTokenLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Documents.actions.resetState] (context, payload) {
      context.commit(_Documents.mutations.setDocument, null)
    }
  },
  getters: {
    [_Documents.getters.getUploadedDocument] (state) {
      return state.document
    },
    [_Documents.getters.documentUploading] (state) {
      return state.documentUploading
    },
    [_Documents.getters.documentTokenLoading] (state) {
      return state.documentTokenLoading
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Document/documents.js